/**
 * [INPUT]: 依赖 react，依赖 ../scorer 的 RejectResult
 * [OUTPUT]: 对外提供 RejectView 组件（拒绝文案 + 重拍引导 + 重试）
 * [POS]: apps/web/components 的拒绝视图，docs §4.2 拒绝时返回结构化引导
 * [PROTOCOL]: 变更时更新此头部，然后检查 ../../CLAUDE.md
 */
import type { RejectResult } from '../scorer'
import { trackEvent } from '../analytics'

interface Props {
  result: RejectResult
  onRetry: () => void
}

export function RejectView({ result, onRetry }: Props) {
  return (
    <div className="max-w-md w-full space-y-5">
      <div className="rounded-2xl border border-rose-900/40 bg-rose-950/20 p-6 space-y-3">
        <div className="text-3xl">🚫</div>
        <h2 className="text-xl font-semibold text-rose-100">{result.message}</h2>
        <ul className="space-y-1.5 text-sm text-slate-300">
          {result.hints.map((h) => (
            <li key={h} className="flex gap-2">
              <span className="text-slate-500">·</span>
              <span>{h}</span>
            </li>
          ))}
        </ul>
      </div>
      <button
        onClick={() => {
          trackEvent('Retest Click', { from: 'reject', code: result.code })
          onRetry()
        }}
        className="w-full rounded-xl bg-slate-100 text-slate-900 font-semibold py-3 hover:bg-white transition"
      >
        Choose Another Photo
      </button>
    </div>
  )
}